import defaultsDeep from "lodash/defaultsDeep";
import { lighten } from "polished";
import * as steelGrey from "../colors/steelGrey";
import { white } from "../colors";
import { alchemyLight } from "./alchemy-light";
export const alchemyPanel = defaultsDeep({
    // Base (structural)
    structural: {
        typeSubHeader: "#656f81",
        typeMeta: "#656f81",
        fill: lighten(0.001, steelGrey.steelGrey100),
        container: "#f8f9fa",
        canvas: white,
        inputBorder: lighten(0.005, steelGrey.steelGrey300)
    },
    // Interactive
    interactiveNavigational: {
        hint: steelGrey.steelGrey100
    },
    expressiveNeutral: {
        hint: steelGrey.steelGrey100
    },
    interactiveConstructive: {
        base: "#2c72c8" // todo: follow up w/ bruce about design spec darken(0.25, deepBlue.deepBlue500)
    }
}, alchemyLight);
